import sk_lang from 'vuetify/es5/locale/sk';

export const sk = {
	$vuetify: sk_lang,
	buyout: {
		deviceFinder: {
			chose_type: 'Vyberte typ',
			chose_brand: 'Vyberte značku',
			chose_model: 'Vyberte model',
			find_price_of_device: 'Zistiť hodnotu tvojho zariadenia',
			buyout_price: 'Tvoja výkupná cena',
			info_minimal_buyout_price: 'Cena po zrážke nesmie klesnúť pod minimálnu výkupnu cenu',
      give_registration_number: 'Zadajte číslo Vašej registrácie',
      thankYou: {
        preSale: {
          title:
            'Informatívne nacenenie bolo odoslané na Tvoju e-mailovú adresu pod číslom <b>{0}</b>.',
        },
      },
			searchDevice: {
				title: 'Vyhľadať vaše zariadenie',
				text:
					'Nezabudnite, že uvedené ceny výkupu sú orientačné. Finálny čiastku sa dozvieš vždy až na predajni.'
			}
		},
		contractForm: {
			imei_help_text: 'IMEI telefónu zistíte zadaním *#06#',
			imei: 'IMEI vykupovaného zariadenia',
			sn: 'SN vykupovaného zariadenia',
			note: 'Poznámky',
			pin_or_birth_date: 'RČ/Dátum narodenia',
			identity_card_number: 'Číslo OP/Pasu',
			identity_released_by: 'Doklad vydal',
			identity_valid_to: 'Platnosť dokladu',
			degree_before_name: 'Titul',
			first_name: 'Krstné meno',
			last_name: 'Priezvisko',
			salutation: 'Oslovenie',
			chose_salutation: 'Vyberte oslovenie',
			street: 'Ulica a číslo domu',
			city: 'Mesto',
			country: 'Štát',
			chose_country: 'Vyberte štát',
			postcode: 'PSČ',
			phone_number: 'Telefónne číslo',
			nationality: 'Štátne občianstvo',
			place_of_birth: 'Miesto narodenia',
			e_mail: 'E-mailová adresa',
			bank_code: 'Kód banky',
			bank_account_full_number: 'Číslo účtu',
			gender: 'Pohlavie'
		},
		give_registration_number: 'Zadajte číslo Vašej registrácie',
		personal_information: 'Osobné údaje',
		send: 'Odoslať',
		save: 'Uložiť',
		bad_quality:
			'Ospravedlňujeme sa, uvedený produkt nemá definovanú požadovanú akosť.',
		can_not_be_buyout: 'Výkup nebolo možné dokončiť.',
		sell_online: 'Výkup zariadenia online',
		send_info_email: 'Výkup zariadenia na predajni',
		send_info_email_label:
			'Zadajte prosím Váš e-mail, na ktorý zašleme informatívne nacenenie zariadenia.',
		buyout_price: 'Vaša výkupná cena',
		find_price_of_device: 'Zistiť hodnotu tvojho zariadenia',
		detail_pricing: 'Detailné nacenenie podľa stavu zariadenia',
		data_for_contract: 'Údaje k uzavretiu zmluvy',
		search_for_device: 'Vyhľadať vaše zariadenie',
		continue: 'Pokračovať',
		consent_to_marketing:
			'Súhlasím so zasielaním personalizovaných reklamných a obchodných oznámení.',
		info_price_deduction: 'Zníženie ceny z dôvodu nedodržania štandardných podmienok vykúpenia',
		buying_out: 'Vypredávam',
		device_condition: 'Stav zariadenia',
		category: 'Kategória',
		deduction: 'Zrážka',
		surcharge: 'Príplatok',
		thankYou: {
			preSale: {
				title:
					'Informatívne nacenenie bolo odoslané na Vašu e-mailovú adresu pod číslom <b>{0}</b>.',
				text:
					'Pre dokončenie výkupu zariadenia sa zastavte na niektorej z našich predajní.',
				text_w_link:
					'Pre dokončenie výkupu zariadenia sa zastavte na niektorej z našich <a href="{0}">predajní</a>.'
			},
			onlineBuyout: {
				title: 'Ďakujeme za vykonaní registrácie číslo <b>{0}</b>.',
				text: 'Potvrdenie registrácie bolo zaslané na Tvoju e-mailovú adresu.'
			}
		},
		validation: {
			not_null: 'Toto pole by nemalo byť prázdne',
			invalid_email: 'Neplatný tvar e-mailu'
		},
		deviceSummary: {
			selected_device: 'Vybrané zariadenie',
			bonus: 'Bonus',
			final_price: 'Informatívna výkupná cena',
			final_price_w_bonus: 'Celková informatívna výkupná cena'
		},
		error: {
			common: 'Chyba pri spracovávaní požiadavku',
			buyout_not_found: 'Výkup nebol nájdený. Skontrolujte číslo výkupu.',
			empty_component: 'Komponenta bez obsahu',
			no_type_component: 'Komponenta bez typu'
		},
		bonus: {
			select_device_for_bonus: 'Vyberte Vaše nové zariadenie',
			select_your_new_device: 'Vyberte váš nový {0}',
			select_seller_of_your_new_device: 'Vyberte predajcu vášho nového {0}'
		},
		partners: {
			partners: 'Partneri',
			select_province: 'Vyberte kraj',
			for_display_select_province:
				'Pre zobrazenie zoznamu partnerov prosím vyberte kraj',
			not_found_in_province: 'V tomto kraji nebol nájdený žiadny partner',
			back_to_home: 'Späť na hlavnú stránku',
			partners_list: 'Zoznam partnerov'
		},
		logRegSwapper: {
			login: 'Prihlásenie',
			log_in: 'Prihlásiť ',
			register: 'Registrácia'
		},
		AdditionalInfoForm: {
			reciept: 'Účtenka',
			reciept_inserted: 'Účtenka vložená',
			reciept_cant_insert: 'Účtenku už nie je možné vložiť',
			reciept_upload: 'Vložiť',
			register_imei_of_new: 'Registrácia IMEI nového {0}',
			register_imei_of_new_global: 'Registrácia IMEI nového zariadenia',
			register_sn_of_new_global: 'Registrácia S/N nového zariadenia',
			sn_of_new: 'S/N nového zariadenia',
			imei_of_new: 'IMEI nového zariadenia',
			imei_was_saved: 'Nový IMEI bol uložený.',
			sn_was_saved: 'Nové S/N bolo uložené.',
			edit: 'Editovať',
			save: 'Uložiť',
			order_pickup: 'Objednať zvoz môjho výkupu',
			order: 'Objednať',
			street: 'Ulica',
			city: 'Mesto',
			postal: 'PSČ',
			new_selected_model: 'Model nového zariadenia',
			select_new_model_name: 'Vyber model svojho novo zakúpeného zariadenia',
			new_model_was_saved: 'Vybraný model bol úspešne uložený',
			new_model_partner_was_saved: 'Vybraný predajca bol úspešne uložený',
			new_model_partner_main_text: 'Zakúpené u predajce',
			new_model_partner_sub_text: 'Vyberte predajce u ktorého bolo nové zariadenie zakúpené',
			new_model_partner_selector: 'Vyberte predajce'
		},
		BuyoutState: {
			buyout_paid: 'Výkupná cena bola poslaná na tebou zaregistrovaný bankový účet',
			collection_success: 'Zvoz úspešne objednaný',
			collection_already_ordered: 'Zvoz už bol objednaný',
			something_went_wrong: 'Niečo sa pokazilo'
		},
		Revaluation:{
			revaluation_success: 'Navrhované precenenie prijaté',
			revaluation_denied: 'Navrhované precenenie odmietnuté',
			revaluation_closed: 'Výkup už bol uzavretý'
		},
	},
	console:{
		new: 'Vymeň',
		most_preferably: ' starú za novú',
		used_console: 'Použitá Konzola',
		the_right_time: 'Ten pravý čas',
		for_upgrade: 'na upgrade',
		do_you_desire_for_a_new_console_but_you_are_short_on_money:
			'Túžiš po novej konzole, ale chýbajú Ti peniaze?',
		we_will_buyout_your_old_sony_playstation_console_money_will_be_send_to_your_account_and_the_new_can_be_yours:
			'Vykúpime od Teba tu starú, peniaze pošleme na účet a nová konzola Sony PlayStation môže byť Tvoja!',
		copyright_text:
			'Celý obsah, všetky herné tituly, ochranné známky a / alebo úpravy, ochranné známky, umelecké diela a súvisiace ' +
			'ilustrácie sú ochranné známky alebo materiály chránené autorským právom príslušných vlastníkov. Všetky práva vyhradené.',
		take_opportunity_to_contact_a_professional_purchase_assistant:
			'Využite možnosť kontaktovania profesionálnym asistentom výkupu',
		xbox_game_pass_text:
			'Xbox Game Pass Ultimate zahŕňa všetky výhody Xbox Live Gold, viac než 100 kvalitných hier pre konzolu, počítač\n' +
			'            a mobilné zariadenie so systémom Android z cloudu (Beta) a členstvo EA Play, to všetko za jeden nízký mesačný\n' +
			'            poplatok.',
		xbox_membership_text:
			'Členstvo EA Play je teraz zahrnuté v predplatnom Xbox Game Pass for PC a Ultimate, a to bez ďalšieho\n' +
			'            príplatku. S EA Play získate prístup ku kolekcii najobľúbenejších hier od EA, odmenám v hrách a skúšobným\n' +
			'            verziám vybraných nových hier.',
		join_now: 'Pridajte sa ihned',
		choose_your_old_device: 'Vyber svoje staré zariadenie',
		device_choices: '(telefón/tablet/inteligentné hodinky/herná konzola)',
		main_claim:
			'Túžiš po novom Xboxe? Využi možnosť predať nám svoje použité zariadenie* a získaj tak nový Xbox za bezkonkurenčnú cenu! ' +
			'Ako  bonus získaš mesačné predplatné Xbox Game Pass.',
		support_main_claim: '* telefón/tablet/inteligentné hodinky/herná konzola',
		where_to_buy_xbox: 'Kde kúpiť Xbox',
		sale_of_used_consoles: 'Predaj použitých konzol',
		where_you_can_buy_new_console:
			'U ktorých môžete zakúpiť konzole a príslušenstvo značky Xbox',
		your_xbox: 'Tvoj Xbox',
		game_pass_activation_key: 'Game Pass aktivačný kód:',
		login: 'Prihlásiť sa',
		registration_code_for_login: 'Po prihlásení zadaj kód svojej registrácie. ',
		back_to_login: 'Späť na prihlásenie',
		generate: 'Vygenerovať',
		generate_your_xbox_activation_key:
			'Vygeneruj si svoj Xbox Game Pass aktivačný kľúč',
		buyout_not_found: 'Výkup nebol nájdený',
		buyout_summary: 'Súhrn registrácie',
		receipt_subtitle: 'Nahraj účtenku svojho nového Xboxu',
		imei_subtitle: 'Zadaj S/N svojho nového Xboxu',
		register_sn_of_new_xbox: 'Registrácia S/N nového Xboxu',
		all_partners_list: 'Zoznam všetkých partnerov',
		choose_console_model_accessories_or_game: 'Vyberte model konzoly, príslušenstva alebo hry',
		detail_pricing_according_to_conditions: 'Detailné nacenenie podľa stavu',
		accessories_quantity: 'Počet príslušenstva',
		controllers_quantity: 'Počet ovládačov',
		games_quantity: 'Počet hier',
		new_buyout: 'Nový výkup',
		how_it_works: 'Ako to funguje',
		buyout: 'Výkup',
		contact: 'Kontakt',
		new_console: 'Nová Konzola',
		phone: 'Telefón',
		mo_fri: 'Po - Pia',
		working_hours: 'Pracovný čas',
		information_protection: 'Ochrana údajov',
		official_partner: 'Oficiálny partner',
		support: 'Podpora',
		legal_information: 'Právne informácie',
		informative_pricing: 'Informatívne nacenenie',
		personal_information_for_concluding_the_contract:
			'Osobné údaje k uzavretiu zmluvy',
		send_the_amount_to_my_account: 'Peniaze mi zašlite na účet:',
		overall_informative_buyout_price: 'Celková informatívna cena',
		i_agree_to_the_processing_of_the_data: 'Súhlasím so spracovaním údajov.',
		more_information: 'Viac informácií',
		here: 'tu',
		controllers: 'Ovládače',
		games: 'Hry',
		pieces: 'Ks',
		send: 'Odoslať',
		personal_information: 'Osobné údaje',
		thank_you: 'Ďakujeme, viac informácií dostanete mailom',
		continue_to_new_buyout: 'Pokračovať novým výkupom',
		games_buyout_not_available: 'Ľutujeme, momentálne nie je možné predať žiadne hry.',
		accessories_buyout_not_available: 'Ľutujeme, momentálne nie je možné predať žadné ovládače.',
		advisor:{
			personal_advisor: 'Osobný poradca',
			call_advisor_1: 'Po vyplnení telefónneho čísla a stlačení tlačidla',
			call_advisor_2: 'sa Vám obratom ozve náš špecialista, ktorý odpovie na otázky.',
			call_me: 'Zavolajte mi',
			i_specialize: 'Špecializujem sa na konzole Microsoft Xbox. V prípade akýchkoľvek otázok sa na mňa neváhajte obrátiť, rada pomôžem.',
			call: 'Zavolajte',
		}
	},
	validators: {
		required: 'Toto pole je povinné.',
		is_number: 'Toto pole môže obsahovať len číslice.',
		invalid_bank_account_number: 'Neplatné číslo účtu.',
		invalid_bank_code: 'Neplatný kód banky.',
		min_allowed_value: 'Najnižšia povolená hodnota je: {minValue}.',
		invalid_email: 'Neplatný email',
		valid_post_code: 'Hodnota musí byť platné PSČ',
		is_newer_date_valid: 'Dátum musí byť neskorší ako dnešný',
	},
}
